import { z } from 'zod';

// ---------------------------------------------------------------------------
// Shared record shape
// ---------------------------------------------------------------------------

export const FormFileUploadRecordSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  groupId: z.number(),
  chatInstanceId: z.number().nullable(),
  status: z.number(),
  s3Key: z.string(),
  bucket: z.string(),
  fileName: z.string(),
  fileType: z.string(),
  fileSize: z.number(),
  uploadedBy: z.number(),
  createdOn: z.string(),
  lastUpdatedOn: z.string(),
});
export type FormFileUploadRecord = z.infer<typeof FormFileUploadRecordSchema>;

// ---------------------------------------------------------------------------
// Queue
// ---------------------------------------------------------------------------

export const FormFileUploadQueueRequestSchema = z.object({
  chatInstanceId: z.number().nullable().optional(),
  fileName: z.string().min(1),
  fileType: z.string().min(1),
  fileSize: z.number().int().min(0),
});
export type FormFileUploadQueueRequest = z.infer<typeof FormFileUploadQueueRequestSchema>;

export const FormFileUploadQueueResponseSchema = z.object({
  fileUpload: FormFileUploadRecordSchema,
});
export type FormFileUploadQueueResponse = z.infer<typeof FormFileUploadQueueResponseSchema>;

// ---------------------------------------------------------------------------
// Start (STS credentials)
// ---------------------------------------------------------------------------

export const FormFileUploadCredentialsSchema = z.object({
  accessKeyId: z.string(),
  secretAccessKey: z.string(),
  sessionToken: z.string(),
  expiration: z.string(),
});
export type FormFileUploadCredentials = z.infer<typeof FormFileUploadCredentialsSchema>;

export const FormFileUploadStartResponseSchema = z.object({
  credentials: FormFileUploadCredentialsSchema,
  fileUpload: FormFileUploadRecordSchema,
});
export type FormFileUploadStartResponse = z.infer<typeof FormFileUploadStartResponseSchema>;

// ---------------------------------------------------------------------------
// Complete / Fail
// ---------------------------------------------------------------------------

export const FormFileUploadCompleteResponseSchema = FormFileUploadRecordSchema;
export type FormFileUploadCompleteResponse = FormFileUploadRecord;

// ---------------------------------------------------------------------------
// Download URL
// ---------------------------------------------------------------------------

export const FormFileUploadDownloadUrlResponseSchema = z.object({
  url: z.string(),
  fileName: z.string(),
  fileType: z.string(),
});
export type FormFileUploadDownloadUrlResponse = z.infer<typeof FormFileUploadDownloadUrlResponseSchema>;
